module.exports = __webpack_public_path__ + "static/media/skilllogo.164e25a6.svg";